import { useCallback } from "react";
import { performUpdateInboundMini } from "../../../../graphql/inbound/inboundCRUD";
import { performUpdateOutbound } from "../../../../graphql/outbound/outboundCRUD";
import {
  ensureCompositeKeyFields,
  isOutbound,
  stripTrackCarFields,
} from "../../../../utils/trackCarPersistence";

/**
 * Hook for track management actions (save shipment)
 * 
 * @returns {Object} { saveShipment }
 */
export const useTrackActions = () => {
  const saveShipment = useCallback((toUpdateShipment) => {
    const shipmentIsOutbound = isOutbound(toUpdateShipment);

    // First ensure all composite key fields are included
    const shipmentWithCompositeKeys = ensureCompositeKeyFields(
      toUpdateShipment,
      shipmentIsOutbound,
    );

    // Then strip UI-only fields
    const sanitizedShipment = stripTrackCarFields(shipmentWithCompositeKeys);

    if (shipmentIsOutbound) {
      return performUpdateOutbound(sanitizedShipment);
    } else {
      return performUpdateInboundMini(sanitizedShipment);
    }
  }, []);

  return {
    saveShipment,
  };
};
